/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useMemo} from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
// todo get fetchAccountProducts working from the account state slice, reverted to old logic for hotfix
import {fetchAccountProducts} from "../../../../state/thunks/account";
import {
  fetchArticleSentimentAccess,
  fetchTrendingNowAccess,
  fetchEmojiCategories,
  fetchMigrationStatus,
  fetchSiteConfiguration,
  fetchSiteEmojiConfiguration,
  fetchTrendingNowConfiguration,
  PRODUCT_ARTICLE_SENTIMENT,
  PRODUCT_COMMENTING,
  PRODUCT_TRENDING_NOW
} from "../../../../state/thunks/engagement";
// import {
//   fetchAccountProducts,
//   PRODUCT_ARTICLE_SENTIMENT,
//   PRODUCT_COMMENTING,
//   PRODUCT_TRENDING_NOW
// } from "../../../../state/thunks/account";
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import EngagementHeader from "../engagementHeader";
import AdvancedConfig from './advanced/advanced';
// styles
import injectSheet from 'react-jss';
import styles from './advanced_styles';

/* ========== ~~~~~~~~~~ ADVANCED PAGE - Engagement ~~~~~~~~~~ ========== */
const AdvancedPage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    account: {
      sites = {}
    },
    session: {
      siteUUID,
      accountUUID,
      mocked
    },
    engagement: {
      articleSentimentUnitUUID,
      accountProducts,
    },
  } = useSelector((state) => state);

  const hasArticleSentimentAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_ARTICLE_SENTIMENT) || accountProducts.includes(PRODUCT_COMMENTING)
    , [accountProducts]
  )

  const hasCommentingAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_COMMENTING)
    , [accountProducts]
  )

  const hasTrendingNowAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_TRENDING_NOW) || true //delete true when finishing product placement
    , [accountProducts]
  )

  useEffect(() => {
    if (!accountUUID) return;
    dispatch(fetchArticleSentimentAccess(accountUUID))
    dispatch(fetchTrendingNowAccess(accountUUID))
    dispatch(fetchAccountProducts(accountUUID))
  }, [dispatch, accountUUID])

  useEffect(() => {
    if (!hasArticleSentimentAccess) return
    dispatch(fetchEmojiCategories())
  }, [dispatch, hasArticleSentimentAccess, hasArticleSentimentAccess])

  useEffect(() => {
    if (!hasArticleSentimentAccess || !siteUUID ) return;
    dispatch(fetchSiteEmojiConfiguration(siteUUID))
  }, [siteUUID, dispatch, hasArticleSentimentAccess])

  useEffect(() => {
    if (!hasArticleSentimentAccess ||  !siteUUID || !accountUUID) return;

    let siteURL = sites[siteUUID] ? sites[siteUUID].toLowerCase() : null

    if (!siteURL) return

    siteURL = siteURL.indexOf('http') !== 0 ? `https://${siteURL}` : siteURL
    siteURL = encodeURIComponent(siteURL)

    dispatch(fetchSiteConfiguration({ siteUUID, siteURL, accountUUID }))
  }, [sites, siteUUID, accountUUID, dispatch, hasArticleSentimentAccess])

  useEffect(() => {
    if (!hasTrendingNowAccess || !siteUUID ) return;
    dispatch(fetchTrendingNowConfiguration({ siteUUID }))
  }, [siteUUID, dispatch, hasTrendingNowAccess])

  useEffect(() => {
    if (!hasArticleSentimentAccess || !articleSentimentUnitUUID) return;
    dispatch(fetchMigrationStatus(articleSentimentUnitUUID))
  }, [articleSentimentUnitUUID, dispatch, hasArticleSentimentAccess])

  return (
    <Page className={props.classes.advanced}>
      <EngagementHeader />
      <Content>
        <InContentMessage />
        <PageHeader title={'Trends & Reactions'} subtitle={'Advanced'} />
        <PageContent>
          {mocked && hasArticleSentimentAccess && <AdvancedConfig/>}
        </PageContent>
      </Content>
    </Page>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdvancedPage;
